import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=65581681&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=ts&"
export * from "./Add.vue?vue&type=script&lang=ts&"
import style0 from "./Add.vue?vue&type=style&index=0&id=65581681&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65581681",
  null
  
)

export default component.exports